import { set } from '@modelsjs/model';
import { resolve } from './resolve';
import { HandleError } from './errors';
import { isResolvable, isResolved, split, transaction, events } from './utils';
export var ResolverState;
(function (ResolverState) {
    ResolverState["Resolving"] = "resolving";
    ResolverState["Resolved"] = "resolved";
})(ResolverState || (ResolverState = {}));
export class Resolver {
    resolvers;
    models = new Set();
    loop = null;
    get promise() {
        return this.loop?.promise;
    }
    get state() {
        switch (true) {
            case Boolean(this.loop && this.loop.started):
                return ResolverState.Resolving;
            default:
                return ResolverState.Resolved;
        }
    }
    transaction = transaction(['state'], (changes) => changes.forEach(([field, prev, curr]) => {
        this.events.notify(field, prev, curr);
    }));
    events = events(['state']);
    constructor(resolvers) {
        this.resolvers = resolvers;
    }
    subscribe(field, handler) {
        return this.events.subscribe(field, handler);
    }
    run() {
        this.update();
        if (!this.loop) {
            return;
        }
        this.loop.start(async () => {
            const rest = await resolve([...this.models], this.resolvers);
            if (rest.length) {
                rest.forEach((model) => {
                    set(model, new HandleError(model));
                });
            }
            this.update();
            return Boolean(this.models.size);
        });
    }
    resolve = (model) => {
        this.transaction(() => {
            if (isResolvable(model)) {
                resolve.sync([model], this.resolvers);
            }
            if (isResolvable(model)) {
                this.models.add(model);
                this.update();
            }
        });
        return model;
    };
    update() {
        this.transaction(() => {
            const [work] = split([...this.models], isResolved);
            work.forEach((model) => this.models.delete(model));
            if (!this.models.size) {
                this.loop = null;
            }
            else {
                this.loop = this.loop || loop();
            }
        });
    }
}
function loop() {
    const control = {
        started: false,
        resolve: null,
        reject: null,
    };
    const start = function start(action) {
        this.promise = this.promise.then(async () => {
            let next = true;
            while (next) {
                next = await action();
            }
        }).catch((error) => {
            control.started = false;
            control.reject?.(error);
        });
        control.started = true;
        control.resolve?.();
    };
    const promise = new Promise((resolve, reject) => {
        control.resolve = resolve;
        control.reject = reject;
    });
    return {
        promise,
        start,
        get started() {
            return control.started;
        }
    };
}
